import api from "./api";
import {
  ListRequestSchemaV2,
  PaginatedResponse,
} from "../types/common/commonTypes";
import { TGCMFull, TGCMListView, TGCMEventFull } from "../types/tgcmTypes";

const tgcm_base = "/inventory/tgcm";

export const tgcmService = {
  listTGCM: async (
    params: ListRequestSchemaV2,
  ): Promise<PaginatedResponse<TGCMListView>> => {
    const response = await api.post(`${tgcm_base}/list_view`, params);
    return response.data;
  },
};
